import { IFastOrderForm } from '~/types/forms'

export default class FastOrderForm {
    public contact_name: string;
    public contact_phone: string;
    /** @example 'e90f1820-0128-11e5-80c7-00155d903d03'  */
    public 'dispatch-city': string | null
    /** @example 'e90f19de-0128-11e5-80c7-00155d903d03' */
    public 'destination-city': string | null;
    public message: string
    public vip: boolean

    constructor (formData: IFastOrderForm) {
      this.contact_name = formData.fio
      this.contact_phone = formData.phone
      this['destination-city'] = formData.toCity
      this['dispatch-city'] = formData.fromCity
      this.message = formData.comment
      this.vip = formData.vip
    }
}
